import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/terms.scss";

const sections = [
  {
    title: "About these terms",
    paragraphs: [
      "These Terms and Conditions govern your access to the Pawluna website and any order you place through it. By using the site or submitting an order, you agree to these Terms.",
      "Pawluna can be contacted at many@pawluna.art or by mail at 60 Harris Rd, Mineral Bluff, GA 30559 US.",
      "Nothing in these Terms limits a right or remedy that cannot lawfully be limited under applicable law.",
    ],
  },
  {
    title: "Eligibility and acceptable use",
    paragraphs: [
      "You must be legally able to enter into a binding contract to place an order. Information you provide must be accurate, current, and complete.",
      "You may not misuse the site, interfere with its operation or security, attempt unauthorized access, introduce harmful code, scrape the site in a manner that burdens our systems, or use the site for unlawful or infringing activity.",
    ],
  },
  {
    title: "Product information",
    paragraphs: [
      "We aim to describe products, materials, colors, dimensions, and care instructions accurately. Screen settings and manufacturing variations may cause reasonable differences in appearance.",
      "Products and options are subject to availability. We may correct typographical errors and update information before accepting an order. Product images are illustrative and should be read together with the product description.",
    ],
  },
  {
    title: "Orders and acceptance",
    paragraphs: [
      "Submitting an order is an offer to purchase the items in your cart. An automated acknowledgement confirms receipt only. We accept an order when we send an order confirmation or dispatch notice.",
      "We may decline or cancel an order before acceptance for reasons including unavailability, suspected fraud, pricing or description errors, shipping restrictions, or inability to authorize payment. If payment has already been collected for a canceled item, it will be refunded to the original payment method.",
    ],
  },
  {
    title: "Prices, payment, and taxes",
    paragraphs: [
      "Unless stated otherwise, prices are shown in U.S. dollars. Shipping charges and applicable sales tax are shown or calculated during checkout before an order is submitted.",
      "Payment must be authorized by the payment method offered at checkout. Your bank or payment provider may apply separate fees or currency-conversion charges.",
    ],
  },
  {
    title: "Shipping and delivery",
    paragraphs: [
      "Delivery estimates are not guarantees and may be affected by carrier delays, weather, holidays, customs, address errors, or events outside our reasonable control.",
      "Available destinations, methods, charges, and current estimates are described on the Delivery page and at checkout. International recipients are responsible for import duties, taxes, and customs charges unless checkout expressly states otherwise.",
    ],
  },
  {
    title: "Returns and refunds",
    paragraphs: [
      "Returns are governed by the Returns Policy displayed on this site. Please contact many@pawluna.art before sending a return so we can provide instructions.",
      "Refund timing depends on inspection, approval, and the processing time of your financial institution. Shipping charges are non-refundable unless required by law or the return results from our error.",
    ],
  },
  {
    title: "Pet safety and responsible use",
    paragraphs: [
      "Select products that are appropriate for your pet's size, age, behavior, and feeding needs. Supervise use, inspect products regularly, and remove any item that becomes damaged or presents a swallowing or injury risk.",
      "Pawluna products are not a substitute for veterinary diagnosis or treatment. Consult a veterinarian about dietary restrictions, allergies, persistent anxiety, swallowing difficulties, or other health concerns.",
    ],
  },
  {
    title: "Intellectual property",
    paragraphs: [
      "The Pawluna name, site design, original text, graphics, photographs, and other site materials are owned by or licensed to Pawluna and are protected by applicable intellectual-property laws.",
      "You may use the site for personal shopping and informational purposes. You may not reproduce, sell, publish, modify, or create commercial derivatives from site content without prior written permission, except where law expressly permits it.",
    ],
  },
  {
    title: "Third-party services and links",
    paragraphs: [
      "The site may rely on third-party services such as carriers, payment providers, or hosted resources. Their services and privacy practices are governed by their own terms. A link does not imply endorsement, and we are not responsible for third-party sites we do not control.",
    ],
  },
  {
    title: "Disclaimers",
    paragraphs: [
      "To the fullest extent permitted by law, the site is provided on an 'as available' basis. We do not promise that access will always be uninterrupted, error-free, or free from every harmful component.",
      "Any warranties that cannot legally be excluded remain in effect. Product-specific warranties, if any, will be identified on the applicable product page or included with the product.",
    ],
  },
  {
    title: "Limitation of liability",
    paragraphs: [
      "To the fullest extent permitted by law, Pawluna will not be liable for indirect, incidental, special, or consequential losses arising from use of the site or products. This limitation does not apply to liability that cannot legally be excluded or limited.",
      "For claims that may lawfully be limited, Pawluna's aggregate liability relating to an order will not exceed the amount paid for the product giving rise to the claim.",
    ],
  },
  {
    title: "Changes and severability",
    paragraphs: [
      "We may update these Terms to reflect changes in our products, practices, or legal obligations. Updated Terms apply from the date posted and do not retroactively change an order already accepted unless required by law.",
      "If a provision is held invalid or unenforceable, it will be limited or removed only to the extent necessary, and the remaining provisions will continue in effect.",
    ],
  },
  {
    title: "Governing law",
    paragraphs: [
      "These Terms are governed by the laws of the State of Georgia and applicable federal law, without regard to conflict-of-laws rules. Any mandatory consumer protections or venue rights available to you under applicable law remain unaffected.",
    ],
  },
  {
    title: "Contact",
    paragraphs: [
      "Questions about these Terms can be sent to many@pawluna.art or Pawluna, 60 Harris Rd, Mineral Bluff, GA 30559 US. These Terms are effective October 16, 2026.",
    ],
  },
];

function Terms() {
  return (
    <div className="terms">
      <Header />
      <div className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12 center-column content-with-background" id="content">
                      <div style={{ paddingBottom: 10 }}>
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            <h1 className="pdh-policy-title">
                              Pawluna – Website &amp; Sale of Goods
                              <br />
                              Terms and Conditions
                            </h1>
                            <div className="pdh-policy-layout">
                              <div className="pdh-policy-main">
                                <div className="pdh-policy-sections">
                                  {sections.map((section, index) => (
                                    <div className="pdh-policy-section" key={section.title}>
                                      <ol start={index + 1}>
                                        <li className="pdh-policy-section-title">
                                          {section.title}
                                        </li>
                                      </ol>
                                      <div className="pdh-policy-section-content">
                                        {section.paragraphs.map((paragraph) => (
                                          <p className="pdh-policy-text" key={paragraph}>
                                            {paragraph}
                                          </p>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms;
